"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializerError = void 0;
const INITIALIZER_ERROR = 'INITIALIZER ERROR';
class InitializerError extends Error {
    constructor(errorType, message) {
        super(`${INITIALIZER_ERROR}: ${errorType}${message ? ` - ${message}` : ''}`);
        this.customError = true;
    }
}
exports.InitializerError = InitializerError;
//# sourceMappingURL=initializer.errors.js.map